/**
 * BCB Service
 */
export class BcbService {

    constructor(accessToken) {
        this.API_URL = process.env.REACT_APP_API_URL;
        this.accessToken = accessToken;
    }

    async getAllBcb(pageSize, pageNum, accountID){
        const response = await fetch(
            this.API_URL + `/bcb?size=${pageSize}&page=${pageNum}${accountID ? '&account=' + accountID : ''}`,
            {
                headers: {
                    // 'Content-Type': 'application/json'
                    Authorization: `Bearer ${this.accessToken}`
                }
            }
        );
        return response.json();
    }

    async setBcbClient(bcbID, clientCopperID) {
        const response = await fetch(
            this.API_URL + '/bcb/setclient', {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${this.accessToken}`
            },
            body: JSON.stringify({
                bcbID,
                clientCopperID
            })
        });
        return response.json();
    }

}